import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("g", null, [
              _createElementVNode("path", {
                fill: "#252729",
                d: "M6.771 10.287l.09.048.075.056c.205.177.27.468.165.717l-.049.09-.966 1.513h8.86l.085.006c.305.042.54.303.54.62 0 .314-.231.573-.533.618l-.092.007-8.872-.001.982 1.57.043.082c.122.28.024.613-.242.78-.263.164-.602.109-.8-.117l-.061-.082-1.58-2.526-.012-.02-.02-.036-.01-.023-.012-.028-.014-.043-.014-.055-.008-.046-.004-.06.002.044-.001-.014-.002-.03v-.04c0-.016.002-.032.004-.048.002-.02.005-.04.01-.06.001-.01.004-.022.007-.032.005-.02.01-.039.018-.057l.021-.052.019-.034-.014.025-.01.022c.014-.031.03-.061.05-.09l1.573-2.465.055-.074c.178-.205.469-.271.717-.165zm7.067-7.31l.055.074 1.574 2.466.026.043.012.024-.032-.058.036.067.023.052.018.057.004.016.004.016c.004.02.008.042.01.063l.002.036.001.03v.031l-.002.023-.002.01-.009.063c-.004.017-.008.035-.014.053-.004.015-.01.03-.015.044l-.011.027-.01.024-.02.035-.012.02-1.58 2.526c-.183.293-.568.382-.861.199-.266-.167-.364-.5-.242-.78l.043-.081.982-1.57H4.946c-.345 0-.625-.28-.625-.625 0-.316.235-.578.54-.62l.085-.005h8.859l-.966-1.513c-.168-.265-.113-.608.117-.808l.074-.055c.265-.17.608-.114.808.116z",
                transform: "translate(-301 -234) translate(0 224) translate(289 4) translate(12 6) rotate(90 9.946 9.625)"
              })
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }